export enum AmplitudeEvent {
  TrailCardClicked = 'trail card clicked',
  TrailDetailsActivityViewed = 'trail details activity viewed',
  TrailDetailsDirectionsClicked = 'trail details directions clicked',
  TrailDetailsNearbyTrailClicked = 'trail details nearby trail clicked',
  TrailDetailsOverflowClicked = 'trail details overflow clicked',
  TrailDetailsOverflowItemSelected = 'trail details overflow item selected',
  TrailDetailsPrintClicked = 'trail details print clicked',
  TrailDetailsShareClicked = 'trail details share clicked',
  TrailDetailsShowMoreClicked = 'trail details show more clicked',
  TrailDownloadButtonTapped = 'trail download button tapped',
  TrailSaveCompleted = 'trail save completed',
  TrailDetailsPhotoClicked = 'trail details photo clicked',
  TrailDetailsScrollDepth = 'trail details scroll depth',
  TrailDetailsSeeAllActivitiesClicked = 'trail details see all activities clicked',
  TrailDetailsSeeAllPhotosClicked = 'trail details see all photos clicked',
  TrailDetailsSeeAllReviewsClicked = 'trail details see all reviews clicked',
  TrailDetailsSortingMethodChanged = 'trail details sorting method changed',
  TrailDetailsTabClicked = 'trail details tab clicked'
}
